import { render } from "./revizeCard.vue?vue&type=template&id=1bfc62b0"
import script from "./revizeCard.vue?vue&type=script&lang=js"
export * from "./revizeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__